import React, { useState, useMemo } from 'react';
import './teacherspanel.css';
import Navbar from '../../Navbar/Navbar';
import Footer from '../../Footer/Footer';

/* ══════════════════════════════════════════════════════
   REAL PHOTOS — these files exist in src/Images/Teachers/
   Add more import lines here as you add more real photos.
══════════════════════════════════════════════════════ */
import teacher1 from '../../Images/Teachers/teacher1.jpeg';
import teacher2 from '../../Images/Teachers/teacher2.jpeg';
import teacher3 from '../../Images/Teachers/teacher3.jpeg';
import teacher4 from '../../Images/Teachers/teacher4.jpeg';
import teacher5 from '../../Images/Teachers/teacher5.jpeg';
import teacher6 from '../../Images/Teachers/teacher6.jpeg';
import teacher7 from '../../Images/Teachers/teacher7.jpeg';
import teacher8 from '../../Images/Teachers/teacher8.jpeg';
import teacher9 from '../../Images/Teachers/teacher9.jpeg';
import teacher10 from '../../Images/Teachers/teacher10.jpeg';
import teacher11 from '../../Images/Teachers/teacher11.jpeg';
import teacher12 from '../../Images/Teachers/teacher12.jpeg';
import teacher13 from '../../Images/Teachers/teacher13.jpeg';
import teacher14 from '../../Images/Teachers/teacher14.jpeg';
import teacher15 from '../../Images/Teachers/teacher15.jpeg';
import teacher16 from '../../Images/Teachers/teacher16.jpeg';
import teacher17 from '../../Images/Teachers/teacher17.jpeg';
import teacher18 from '../../Images/Teachers/teacher18.jpeg';
import teacher19 from '../../Images/Teachers/teacher19.jpeg';
import teacher20 from '../../Images/Teachers/teacher20.jpeg';
import teacher21 from '../../Images/Teachers/teacher21.jpeg';
import teacher22 from '../../Images/Teachers/teacher22.jpeg';
import teacher23 from '../../Images/Teachers/teacher23.jpeg';
import teacher24 from '../../Images/Teachers/teacher24.jpeg';
import teacher25 from '../../Images/Teachers/teacher25.jpeg';
import teacher26 from '../../Images/Teachers/teacher26.jpeg';
import teacher27 from '../../Images/Teachers/teacher27.jpeg';
import teacher28 from '../../Images/Teachers/teacher28.jpeg';
import teacher29 from '../../Images/Teachers/teacher29.jpeg';
import developer from '../../Images/Teachers/developer.jpeg';


const t1  = 'https://i.pravatar.cc/300?img=1';
const t2  = 'https://i.pravatar.cc/300?img=2';
const t3  = 'https://i.pravatar.cc/300?img=3';
const t4  = 'https://i.pravatar.cc/300?img=4';
const t5  = 'https://i.pravatar.cc/300?img=5';
const t6  = 'https://i.pravatar.cc/300?img=6';
const t7  = 'https://i.pravatar.cc/300?img=7';
const t8  = 'https://i.pravatar.cc/300?img=8';
const t9  = 'https://i.pravatar.cc/300?img=9';
const t10 = 'https://i.pravatar.cc/300?img=10';
const t11 = 'https://i.pravatar.cc/300?img=11';
const t12 = 'https://i.pravatar.cc/300?img=12';
const t13 = 'https://i.pravatar.cc/300?img=13';
const t14 = 'https://i.pravatar.cc/300?img=14';
const t15 = 'https://i.pravatar.cc/300?img=15';
const t16 = 'https://i.pravatar.cc/300?img=16';
const t17 = 'https://i.pravatar.cc/300?img=17';
const t18 = 'https://i.pravatar.cc/300?img=18';
const t19 = 'https://i.pravatar.cc/300?img=19';
const t20 = 'https://i.pravatar.cc/300?img=20';
const t21 = 'https://i.pravatar.cc/300?img=21';
const t22 = 'https://i.pravatar.cc/300?img=22';
const t23 = 'https://i.pravatar.cc/300?img=23';
const t24 = 'https://i.pravatar.cc/300?img=24';
const t25 = 'https://i.pravatar.cc/300?img=25';
const t26 = 'https://i.pravatar.cc/300?img=26';
const t27 = 'https://i.pravatar.cc/300?img=27';
const t28 = 'https://i.pravatar.cc/300?img=28';
const t29 = 'https://i.pravatar.cc/300?img=29';



/* ══════════════════════════════════════════════════════
   TEACHER DATA  —  Edit names, subjects, messages etc.
   online: true  → shows green "Available for online class"
   online: false → shows next available time slot
══════════════════════════════════════════════════════ */
const TEACHERS = [
  {
    id: 0,
    name: 'Suman Hens',
    subject: 'IT',
    designation: 'IT Manager',
    qualification: 'B.SC, MCA',
    classes: '',
    experience: 2,
    online: false,
    nextSlot: '',
    rating: '4.9',
    message: 'Passionate to do work with new and advanced technologies.',
    img: developer,
  },
  {
    id: 1,
    name: 'Asha Sahu',
    subject: 'English',
    designation: 'PGT',
    qualification: 'M.A, B.Ed',
    classes: 'I – IV',
    experience: 10,
    online: true,
    nextSlot: '10:30 AM',
    rating: '4.8',
    message: 'Learn with curiosity, grow with confidence, and lead with integrity.',
    img: teacher1,
  },
  {
    id: 2,
    name: 'Bijay Mohapatra',
    subject: 'Science',
    designation: 'TGT',
    qualification: 'M.Sc, B.Ed',
    classes: 'IX – X',
    experience: 10,
    online: true,
    nextSlot: '12:00 PM',
    rating: '4.7',
    message: 'Science is a way of thinking much more than it is a body of knowledge.',
    img: teacher2 ,
  },
  {
    id: 3,
    name: 'Rita Parida',
    subject: 'Mother Teacher',
    designation: 'PRT',
    qualification: 'M.A, B.Ed',
    classes: 'Nur – V',
    experience: 10,
    online: false,
    nextSlot: '2:15 PM',
    rating: '4.5',
    message: 'The butterfly counts not months but moments,and has time enough',
    img: teacher3,
  },
  {
    id: 4,
    name: 'Jharana Pattnaik',
    subject: 'SST',
    designation: 'TGT',
    qualification: 'M.A, B.Ed',
    classes: 'I – VI',
    experience: 12,
    online: true,
    nextSlot: '10:30 AM',
    rating: '4.6',
    message: 'A teachers greatest legacy is not the syllabus completed, but the confident, compassionate, and capable individuals they leave behind.।',
    img: teacher4,
  },
  {
    id: 5,
    name: 'Padmabati Mahanto',
    subject: 'Social Science',
    designation: 'PGT',
    qualification: 'M.A, B.Ed',
    classes: 'VI – X',
    experience: 9,
    online: true,
    nextSlot: '4:00 PM',
    rating: '4.7',
    message: 'Imagination is more important than knowledge For knowledge is limited While imagination embraces the entire world.',
    img: teacher5,
  },
  {
    id: 6,
    name: 'Anita Kanungo ',
    subject: 'MOther Teacher',
    designation: '',
    qualification: 'B.P.Ed ',
    classes: 'NUR – UKG',
    experience: 15,
    online: false,
    nextSlot: '12:00 PM',
    rating: '4.9',
    message: '"Education is the most powerful weapon which we can use to change the world.',
    img: teacher6,
  },
  {
    id: 7,
    name: 'Damyanti Mohanta',
    subject: 'EVS',
    designation: 'TGT',
    qualification: ' B.Ed',
    classes: 'I – V',
    experience: 11,
    online: false,
    nextSlot: '4:00 PM',
    rating: '4.8',
    message: '"THE BEST WAY TO PREDICT YOUR FUTURE IS TO CREATE IT."',
    img: teacher7,
  },
  {
    id: 8,
    name: 'Soma Patra',
    subject: 'Hindi',
    designation: 'Teacher',
    qualification: 'M.A, B.Ed',
    classes: 'I – V',
    experience: 4,
    online: true,
    nextSlot: '10:30 AM',
    rating: '4.9',
    message: 'Small steps every day lead to big achievements tomorrow.',
    img: teacher8,
  },
  {
    id: 9,
    name: 'RadhaKrushna Nath',
    subject: 'Mathematics',
    designation: 'PGT',
    qualification: 'M.sc, B.Ed',
    classes: 'VI – X',
    experience: 8,
    online: true,
    nextSlot: '12:00 PM',
    rating: '4.6',
    message: '"IMPOSSIBLE" is a word that is applied only to something that has not been tried.',
    img: teacher9,
  },
  {
    id: 10,
    name: 'Rekha Gupta',
    subject: 'Hindi',
    designation: 'TGT',
    qualification: 'M.A, B.Ed',
    classes: 'IX – X',
    experience: 6,
    online: false,
    nextSlot: '2:15 PM',
    rating: '4.5',
    message: 'History teaches us lessons that no textbook alone can — I bring stories alive in my classroom.',
    img: teacher10,
  },
  {
    id: 11,
    name: 'Geetanjali Dora',
    subject: 'SST',
    designation: 'Senior faculty',
    qualification: 'M.Sc, B.Ed',
    classes: 'VI – X',
    experience: 9,
    online: true,
    nextSlot: '4:00 PM',
    rating: '4.7',
    message: 'A strong foundation in SST builds confidence that lasts a lifetime.',
    img: teacher11,
  },
  {
    id: 13,
    name: 'Mohanta Seema Kaliyar',
    subject: 'Odia',
    designation: 'TGT',
    qualification: 'M.A, B.Ed',
    classes: 'I – V',
    experience: 7,
    online: true,
    nextSlot: '10:30 AM',
    rating: '4.6',
    message: 'Curiosity is the heart of science — I encourage every child to ask "why?"',
    img: teacher13,
  },
  {
    id: 14,
    name: 'Priyatama MOhanta',
    subject: 'EVS',
    designation: 'PRT',
    qualification: 'M.P.Ed',
    classes: 'I – V',
    experience: 5,
    online: false,
    nextSlot: '12:00 PM',
    rating: '4.5',
    message: 'A healthy body fosters a healthy mind — sports build character and discipline.',
    img: teacher14,
  },
  {
    id: 15,
    name: 'DC Mohanta',
    subject: 'Physical Education',
    designation: 'PRT',
    qualification: 'M.P.Ed',
    classes: 'I – X',
    experience: 15,
    online: false,
    nextSlot: '12:00 PM',
    rating: '4.5',
    message: 'A healthy body fosters a healthy mind — sports build character and discipline.',
    img: teacher15,
  },
  {
    id: 16,
    name: 'Sanjukta Mohanta',
    subject: 'Arts',
    designation: 'Teacher',
    qualification: 'M.A',
    classes: 'I – V',
    experience: 12,
    online: true,
    nextSlot: '2:15 PM',
    rating: '4.8',
    message: 'Creativity is intelligence having fun — I help every child discover their inner artist.',
    img: teacher16,
  },
  {
    id: 17,
    name: 'Rohit Nanda',
    subject: 'Information Technology',
    designation: 'Teacher',
    qualification: 'Mca, B.Ed',
    classes: 'IX – X',
    experience: 16,
    online: true,
    nextSlot: '10:30 AM',
    rating: '4.9',
    message: ' Coding is the literacy of the 21st century — I help students become creators, not just users..',
    img: teacher17,
  },
  {
    id: 18,
    name: 'Kade Majhi',
    subject: 'Information Technology',
    designation: 'PGT',
    qualification: 'Mca, B.Ed',
    classes: 'VI – VIII',
    experience: 10,
    online: false,
    nextSlot: '4:00 PM',
    rating: '4.6',
    message: 'Education is not just for a duration of time; it is a process of awareness. ',
    img: teacher18,
  },
  {
    id: 19,
    name: 'Sasmita Giri',
    subject: 'arts',
    designation: 'TGT',
    qualification: 'M.A, B.Ed',
    classes: 'I – v',
    experience: 8,
    online: true,
    nextSlot: '12:00 PM',
    rating: '4.7',
    message: 'Knowing our past empowers us to shape a better tomorrow.',
    img: teacher19,
  },
  {
    id: 20,
    name: 'Poonam Prajapati',
    subject: 'Hindi',
    designation: 'Senior Faculty',
    qualification: 'M.A, B.Ed',
    classes: 'VI – X',
    experience: 13,
    online: true,
    nextSlot: '10:30 AM',
    rating: '4.8',
    message: '"समय सबसे बड़ा शिक्षक है।" हर अनुभव कुछ सिखाता है। "बड़ा सोचो, बड़ा करो।" - सफलता विचार से शुरू होता है। "गलतियाँ वही करते हैं जो कुछ करने की कोशिश करते हैं।"',
    img: teacher20,
  },
  {
    id: 12,
    name: 'Binata Mohanty',
    subject: 'Math & Science',
    designation: 'PRT',
    qualification: 'M.sc, B.Ed',
    classes: 'VI – VIII',
    experience: 12,
    online: false,
    nextSlot: '2:15 PM',
    rating: '4.5',
    message: 'Every experiment is a step towards discovery — I make hindi fun and hands-on.',
    img: teacher12,
  },
  {
    id: 22,
    name: 'Sarthak Panda ',
    subject: 'Science',
    designation: 'Senior Faculty',
    qualification: 'Phd, B.Ed',
    classes: 'VI – X',
    experience: 7,
    online: true,
    nextSlot: '4:00 PM',
    rating: '4.7',
    message: '"Learn Today, Lead Tomorrow,Knowledge is Power, You Are Powerful,Education is the Key to Success".',
    img: teacher22,
  },
  {
    id: 23,
    name: '',
    subject: 'Physical Education',
    designation: 'PGT',
    qualification: 'M.P.Ed',
    classes: 'VI – X',
    experience: 11,
    online: true,
    nextSlot: '10:30 AM',
    rating: '4.6',
    message: 'Sports teach teamwork, resilience and leadership — values that last beyond school.',
    img: teacher23,
  },
  {
    id: 24,
    name: 'Jeebanram Mohanta',
    subject: 'Odia',
    designation: 'TGT',
    qualification: 'M.A, B.Ed',
    classes: 'VI – X',
    experience: 9,
    online: false,
    nextSlot: '12:00 PM',
    rating: '4.6',
    message: 'I believe every student can master mathematics with the right guidance and practice.',
    img: teacher24,
  },
  {
    id: 25,
    name: 'PriyaRaj Mehra',
    subject: 'English',
    designation: 'PRT',
    qualification: 'M.A, B.Ed',
    classes: 'VI – VIII',
    experience: 5,
    online: true,
    nextSlot: '2:15 PM',
    rating: '4.5',
    message: 'A love for reading begins in the classroom — I strive to spark that love every day.',
    img: teacher25,
  },
  {
    id: 26,
    name: 'Dulari kishku',
    subject: 'Odia',
    designation: 'Subject Coordinator',
    qualification: 'M.A, B.Ed',
    classes: 'I – V',
    experience: 10,
    online: true,
    nextSlot: '4:00 PM',
    rating: '4.7',
    message: 'Mother Language shape informed citizens — I teach students to care about the Language.',
    img: teacher26,
  },
  {
    id: 27,
    name: 'Suchitra Mandal',
    subject: 'Mother Teacher',
    designation: 'TGT',
    qualification: 'M.A, B.Ed',
    classes: 'Nur – Ukg',
    experience: 4,
    online: false,
    nextSlot: '10:30 AM',
    rating: '4.5',
    message: 'The future belongs to those who learn to code — I make programming accessible to all.',
    img: teacher27,
  },
  {
    id: 28,
    name: 'Padmabati Mahato',
    subject: 'Arts',
    designation: 'PRT',
    qualification: 'M.F.A',
    classes: 'VI – VIII',
    experience: 8,
    online: true,
    nextSlot: '12:00 PM',
    rating: '4.6',
    message: 'Every child is an artist — my role is to help them believe in their own creativity.',
    img: teacher28,
  },
  {
    id: 29,
    name: 'Sunita Mohanta',
    subject: 'Hindi',
    designation: 'TGT',
    qualification: 'M.A, B.Ed',
    classes: 'IX – X',
    experience: 12,
    online: true,
    nextSlot: '2:15 PM',
    rating: '4.8',
    message: 'हिंदी हमारी राष्ट्रभाषा है — इसे सीखना हमारा गर्व है।',
    img: teacher29,
  },
   
];

/* ── Subject filter list ── */
const SUBJECTS = ['All', ...new Set(TEACHERS.map(t => t.subject))];

/* ══════════════════════════════════════════════════════
   COMPONENT
══════════════════════════════════════════════════════ */
const TeacherPanel = () => {
  const [activeSubject, setActiveSubject]   = useState('All');
  const [search, setSearch]                 = useState('');
  const [onlyOnline, setOnlyOnline]         = useState(false);
  const [selectedTeacher, setSelectedTeacher] = useState(null);

  const onlineCount = useMemo(() => TEACHERS.filter(t => t.online).length, []);

  const filtered = useMemo(() => {
    return TEACHERS.filter(t => {
      const matchSubject = activeSubject === 'All' || t.subject === activeSubject;
      const matchSearch  = t.name.toLowerCase().includes(search.toLowerCase()) ||
                           t.subject.toLowerCase().includes(search.toLowerCase());
      const matchOnline  = !onlyOnline || t.online;
      return matchSubject && matchSearch && matchOnline;
    });
  }, [activeSubject, search, onlyOnline]);

  const subjectCounts = SUBJECTS.reduce((acc, s) => {
    acc[s] = s === 'All' ? TEACHERS.length : TEACHERS.filter(t => t.subject === s).length;
    return acc;
  }, {});

  return (
    <div className="tp-page">
      <Navbar />

      {/* ══ HERO ══ */}
      <section className="tp-hero">
        <div className="tp-hero__grid-bg" />
        <div className="tp-hero__content">
          <span className="tp-eyebrow">Faculty Directory</span>
          <h1>Meet Our Teachers</h1>
          <p>
            30 dedicated educators across every subject — many available
            right now for a live online class.
          </p>
          <div className="tp-hero__live">
            <span className="tp-live-dot" />
            <strong>{onlineCount}</strong> of {TEACHERS.length} teachers online now
          </div>
        </div>
      </section>

      {/* ══ TOOLBAR ══ */}
      <section className="tp-toolbar">
        <div className="tp-subjects">
          {SUBJECTS.map(s => (
            <button
              key={s}
              className={`tp-pill ${activeSubject === s ? 'tp-pill--active' : ''}`}
              onClick={() => setActiveSubject(s)}
            >
              {s} <span>{subjectCounts[s]}</span>
            </button>
          ))}
        </div>
        <div className="tp-toolbar__right">
          <div className="tp-search">
            <span>🔍</span>
            <input
              type="text"
              placeholder="Search teacher or subject..."
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
            {search && <button onClick={() => setSearch('')}>✕</button>}
          </div>
          <label className="tp-toggle">
            <input
              type="checkbox"
              checked={onlyOnline}
              onChange={e => setOnlyOnline(e.target.checked)}
            />
            <span className="tp-toggle__track">
              <span className="tp-toggle__thumb" />
            </span>
            Online only
          </label>
        </div>
      </section>

      {/* ══ TEACHER GRID ══ */}
      <section className="tp-grid-section">
        {filtered.length === 0 ? (
          <div className="tp-empty">
            <span>🔎</span>
            <h3>No teachers found</h3>
            <p>Try a different subject filter or search term.</p>
          </div>
        ) : (
          <div className="tp-grid">
            {filtered.map((t, i) => (
              <article
                className="tp-card"
                key={t.id}
                style={{ animationDelay: `${Math.min(i * 0.04, 0.6)}s` }}
                onClick={() => setSelectedTeacher(t)}
              >
                <div className="tp-card__photo-wrap">
                  <img src={t.img} alt={t.name} className="tp-card__photo" />
                  <span className={`tp-status-dot ${t.online ? 'tp-status-dot--on' : 'tp-status-dot--off'}`} />
                  {t.online && <span className="tp-live-badge">● Live Now</span>}
                </div>
                <div className="tp-card__body">
                  <span className="tp-card__subject">{t.subject}</span>
                  <h3>{t.name}</h3>
                  <span className="tp-card__role">{t.designation} · {t.qualification}</span>
                  <p className="tp-card__message">"{t.message}"</p>
                  <div className="tp-card__meta">
                    <span>📚 {t.classes}</span>
                    <span>⭐ {t.rating}</span>
                  </div>
                  <div className="tp-card__footer">
                    {t.online ? (
                      <span className="tp-availability tp-availability--on">
                        🟢 Available for online class
                      </span>
                    ) : (
                      <span className="tp-availability tp-availability--off">
                        ⏰ Next slot: {t.nextSlot}
                      </span>
                    )}
                  </div>
                </div>
              </article>
            ))}
          </div>
        )}
      </section>

      <Footer />

      {/* ══ TEACHER DETAIL MODAL ══ */}
      {selectedTeacher && (
        <div className="modal-overlay" onClick={() => setSelectedTeacher(null)}>
          <div className="tp-modal" onClick={e => e.stopPropagation()}>
            <button className="tp-modal__close" onClick={() => setSelectedTeacher(null)}>✕</button>

            <div className="tp-modal__top">
              <img src={selectedTeacher.img} alt={selectedTeacher.name} />
              <div>
                <span className="tp-modal__subject">{selectedTeacher.subject}</span>
                <h2>{selectedTeacher.name}</h2>
                <span className="tp-modal__role">
                  {selectedTeacher.designation} · {selectedTeacher.qualification}
                </span>
                <div className="tp-modal__status">
                  {selectedTeacher.online ? (
                    <span className="tp-availability tp-availability--on">
                      🟢 Available for online class
                    </span>
                  ) : (
                    <span className="tp-availability tp-availability--off">
                      ⏰ Next slot: {selectedTeacher.nextSlot}
                    </span>
                  )}
                </div>
              </div>
            </div>

            {/* Teacher's personal message in modal */}
            <div className="tp-modal__message">
              <span className="tp-modal__quote-icon">❝</span>
              <p>{selectedTeacher.message}</p>
            </div>

            <div className="tp-modal__stats">
              <div>
                <strong>{selectedTeacher.experience} yrs</strong>
                <span>Experience</span>
              </div>
              <div>
                <strong>{selectedTeacher.classes}</strong>
                <span>Classes</span>
              </div>
              <div>
                <strong>{selectedTeacher.rating}</strong>
                <span>Rating</span>
              </div>
            </div>

            <button
              className={`tp-modal__cta ${!selectedTeacher.online ? 'tp-modal__cta--disabled' : ''}`}
              disabled={!selectedTeacher.online}
            >
              {selectedTeacher.online ? '🎥 Join Online Class' : '📅 Request a Slot'}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default TeacherPanel;